import React, { useState, useEffect } from "react";
import { Row, Card, Col, Button, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import { useHistory } from "react-router-dom";
function City(props) {
  var history = useHistory();
  const [data, setData] = useState(
    document.querySelectorAll("#myTable tbody tr")
  );
  const { id } = props.match.params;
  const [searchData, setSearchData] = useState([]);
  const [distNames, setDistNames] = useState("");
  const [distValue, setDistValue] = useState("");
  const district = [
    {
      name: "puducherry",
      cities: [
        {
          id: 1,
          name: "Karaikal",
          path: "Karaikal",
        },
        {
          id: 2,
          name: "Mahe",
          path: "Mahe",
        },
        {
          id: 3,
          name: "Puducherry",
          path: "Puducherry",
        },
        {
          id: 4,
          name: "Yanam",
          path: "Yanam",
        },
      ],
    },
    {
      name: "jammu-kashmir",
      cities: [
        {
          id: 1,
          name: "Anantnag",
          path: "Anantnag",
        },
        {
          id: 2,
          name: "Bandipore",
          path: "Bandipore",
        },
        {
          id: 3,
          name: "Baramulla",
          path: "Baramulla",
        },
        {
          id: 4,
          name: "Budgam",
          path: "Budgam",
        },
        {
          id: 5,
          name: "Doda",
          path: "Doda",
        },
        {
          id: 6,
          name: "Ganderbal",
          path: "Ganderbal",
        },
        {
          id: 7,
          name: "Jammu",
          path: "Jammu",
        },
        {
          id: 8,
          name: "Kathua",
          path: "Kathua",
        },
        {
          id: 9,
          name: "Kishtwar",
          path: "Kishtwar",
        },
        {
          id: 10,
          name: "Kulgam",
          path: "Kulgam",
        },
        {
          id: 11,
          name: "Kupwara",
          path: "Kupwara",
        },
        {
          id: 12,
          name: "Poonch",
          path: "Poonch",
        },
        {
          id: 13,
          name: "Pulwama",
          path: "Pulwama",
        },
        {
          id: 14,
          name: "Rajouri",
          path: "Rajouri",
        },
        {
          id: 15,
          name: "Ramban",
          path: "Ramban",
        },
        {
          id: 16,
          name: "Reasi",
          path: "Reasi",
        },
        {
          id: 17,
          name: "Samba",
          path: "Samba",
        },
        {
          id: 18,
          name: "Shopian",
          path: "Shopian",
        },
        {
          id: 19,
          name: "Srinagar",
          path: "Srinagar",
        },
        {
          id: 20,
          name: "Udhampur",
          path: "Udhampur",
        },
      ],
    },
    {
      name: "lakshadweep",
      cities: [
        {
          id: 1,
          name: "Lakshadweep",
          path: "Lakshadweep",
        },
      ],
    },
    {
      name: "ladakh",
      cities: [
        {
          id: 1,
          name: "Kargil",
          path: "Kargil",
        },
        {
          id: 2,
          name: "Leh",
          path: "Leh",
        },
      ],
    },
    {
      name: "dadra-nagar",
      cities: [
        {
          id: 1,
          name: "Daman",
          path: "Daman",
        },
        {
          id: 2,
          name: "Diu",
          path: "Diu",
        },
        {
          id: 3,
          name: "Dadra and Nagar Haveli",
          path: "DadraandNagarHaveli",
        },
      ],
    },
    {
      name: "chandigarh",
      cities: [
        {
          id: 1,
          name: "Chandigarh",
          path: "Chandigarh",
        },
      ],
    },
    {
      name: "andaman",
      cities: [
        {
          id: 1,
          name: "Nicobar",
          path: "Nicobar",
        },
        {
          id: 2,
          name: "North and Middle Andaman",
          path: "NorthandMiddleAndaman",
        },
        {
          id: 3,
          name: "South Andaman",
          path: "SouthAndaman",
        },
      ],
    },
    {
      name: "west-bengal",
      cities: [
        {
          id: 1,
          name: "Alipurduar",
          path: "Alipurduar",
        },
        {
          id: 2,
          name: "Bankura",
          path: "Bankura",
        },
        {
          id: 3,
          name: "Paschim Bardhaman",
          path: "PaschimBardhaman",
        },
        {
          id: 4,
          name: "Purba Bardhaman",
          path: "PurbaBardhaman",
        },
        {
          id: 5,
          name: "Birbhum",
          path: "Birbhum",
        },
        {
          id: 6,
          name: "Cooch Behar",
          path: "CoochBehar",
        },
        {
          id: 7,
          name: "Dakshin Dinajpur",
          path: "DakshinDinajpur",
        },
        {
          id: 8,
          name: "Darjeeling",
          path: "Darjeeling",
        },
        {
          id: 9,
          name: "Hooghly",
          path: "Hooghly",
        },
        {
          id: 10,
          name: "Howrah",
          path: "Howrah",
        },
        {
          id: 11,
          name: "Jalpaiguri",
          path: "Jalpaiguri",
        },
        {
          id: 12,
          name: "Jhargram",
          path: "Jhargram",
        },
        {
          id: 13,
          name: "Kalimpong",
          path: "Kalimpong",
        },
        {
          id: 14,
          name: "Kolkata",
          path: "Kolkata",
        },
        {
          id: 15,
          name: "Maldah",
          path: "Maldah",
        },
        {
          id: 16,
          name: "Murshidabad",
          path: "Murshidabad",
        },
        {
          id: 17,
          name: "Nadia",
          path: "Nadia",
        },
        {
          id: 18,
          name: "North 24 Parganas",
          path: "North24Parganas",
        },
        {
          id: 19,
          name: "Paschim Medinipur",
          path: "PaschimMedinipur",
        },
        {
          id: 20,
          name: "Purba Medinipur",
          path: "PurbaMedinipur",
        },
        {
          id: 21,
          name: "Purulia",
          path: "Purulia",
        },
        {
          id: 22,
          name: "South 24 Parganas",
          path: "South24Parganas",
        },
        {
          id: 23,
          name: "Uttar Dinajpur",
          path: "Uttar Dinajpur",
        },
      ],
    },
    {
      name: "uttar-pradesh",
      cities: [
        {
          id: 1,
          name: "Agra",
          path: "Agra",
        },
        {
          id: 2,
          name: "Aligarh",
          path: "Aligarh",
        },
        {
          id: 3,
          name: "Prayagraj(Allahabad)",
          path: "Prayagraj",
        },
        {
          id: 4,
          name: "Ambedkar Nagar",
          path: "AmbedkarNagar",
        },
        {
          id: 5,
          name: "Amethi",
          path: "Amethi",
        },
        {
          id: 6,
          name: "Amroha",
          path: "Amroha",
        },
        {
          id: 7,
          name: "Auraiya",
          path: "Auraiya",
        },
        {
          id: 8,
          name: "Azamgarh",
          path: "Azamgarh",
        },
        {
          id: 9,
          name: "Baghpat",
          path: "Baghpat",
        },
        {
          id: 10,
          name: "Bahraich",
          path: "Bahraich",
        },
        {
          id: 11,
          name: "Ballia",
          path: "Ballia",
        },
        {
          id: 12,
          name: "Balrampur",
          path: "Balrampur",
        },
        {
          id: 13,
          name: "Banda",
          path: "Banda",
        },
        {
          id: 14,
          name: "Barabanki",
          path: "Barabanki",
        },
        {
          id: 15,
          name: "Bareilly",
          path: "Bareilly",
        },
        {
          id: 16,
          name: "Basti",
          path: "Basti",
        },
        {
          id: 17,
          name: "Bhadohi",
          path: "Bhadohi",
        },
        {
          id: 18,
          name: "Bijnor",
          path: "Bijnor",
        },
        {
          id: 19,
          name: "Budaun",
          path: "Budaun",
        },
        {
          id: 20,
          name: "Bulandshahr",
          path: "Bulandshahr",
        },
        {
          id: 21,
          name: "Chandauli",
          path: "Chandauli",
        },
        {
          id: 22,
          name: "Chitrakoot",
          path: "Chitrakoot",
        },
        {
          id: 23,
          name: "Deoria",
          path: "Deoria",
        },
        {
          id: 24,
          name: "Etah",
          path: "Etah",
        },
        {
          id: 25,
          name: "Etawah",
          path: "Etawah",
        },
        {
          id: 26,
          name: "Ayodhya(Faizabad)",
          path: "Ayodhya",
        },
        {
          id: 27,
          name: "Farrukhabad",
          path: "Farrukhabad",
        },
        {
          id: 28,
          name: "Fatehpur",
          path: "Fatehpur",
        },
        {
          id: 29,
          name: "Firozabad",
          path: "Firozabad",
        },
        {
          id: 30,
          name: "Gautam Buddha Nagar",
          path: "Gautam Buddha Nagar",
        },
        {
          id: 31,
          name: "Ghaziabad",
          path: "Ghaziabad",
        },
        {
          id: 32,
          name: "Gonda",
          path: "Gonda",
        },
        {
          id: 33,
          name: "Gorakhpur",
          path: "Gorakhpur",
        },
        {
          id: 34,
          name: "Ghazipur",
          path: "Ghazipur",
        },
        {
          id: 35,
          name: "Hamirpur",
          path: "Hamirpur",
        },
        {
          id: 36,
          name: "Hapur",
          path: "Hapur",
        },
        {
          id: 37,
          name: "Hardoi",
          path: "Hardoi",
        },
        {
          id: 38,
          name: "Hathras",
          path: "Hathras",
        },
        {
          id: 39,
          name: "Jalaun",
          path: "Jalaun",
        },
        {
          id: 40,
          name: "Jaunpur",
          path: "Jaunpur",
        },
        {
          id: 41,
          name: "Jhansi",
          path: "Jhansi",
        },
        {
          id: 42,
          name: "Kannauj",
          path: "Kannauj",
        },
        {
          id: 43,
          name: "Kanpur Dehat",
          path: "KanpurDehat",
        },
        {
          id: 44,
          name: "Kanpur Nagar",
          path: "KanpurNagar",
        },
        {
          id: 45,
          name: "Kasganj(Kanshiram Nagar)",
          path: "Kasganj",
        },
        {
          id: 46,
          name: "Kaushambi",
          path: "Kaushambi",
        },
        {
          id: 47,
          name: "Kushinagar",
          path: "Kushinagar",
        },
        {
          id: 48,
          name: "Lakhimpur Kheri",
          path: "LakhimpurKheri",
        },
        {
          id: 49,
          name: "Lalitpur",
          path: "Lalitpur",
        },
        {
          id: 50,
          name: "Lucknow",
          path: "Lucknow",
        },
        {
          id: 51,
          name: "Maharajganj",
          path: "Maharajganj",
        },
        {
          id: 52,
          name: "Mahoba",
          path: "Mahoba",
        },
        {
          id: 53,
          name: "Mainpuri",
          path: "Mainpuri",
        },
        {
          id: 54,
          name: "Mathura",
          path: "Mathura",
        },
        {
          id: 55,
          name: "Mau",
          path: "Mau",
        },
        {
          id: 56,
          name: "Meerut",
          path: "Meerut",
        },
        {
          id: 57,
          name: "Mirzapur",
          path: "Mirzapur",
        },
        {
          id: 58,
          name: "Moradabad",
          path: "Moradabad",
        },
        {
          id: 59,
          name: "Muzaffarnagar",
          path: "Muzaffarnagar",
        },
        {
          id: 60,
          name: "Pilibhit",
          path: "Pilibhit",
        },
        {
          id: 61,
          name: "Pratapgarh",
          path: "Pratapgarh",
        },
        {
          id: 62,
          name: "Raebareli",
          path: "Raebareli",
        },
        {
          id: 63,
          name: "Rampur",
          path: "Rampur",
        },
        {
          id: 64,
          name: "Saharanpur",
          path: "Saharanpur",
        },
        {
          id: 65,
          name: "Sambhal",
          path: "Sambhal",
        },
        {
          id: 66,
          name: "Sant Kabir Nagar",
          path: "SantKabirNagar",
        },
        {
          id: 67,
          name: "Shahjahanpur",
          path: "Shahjahanpur",
        },
        {
          id: 68,
          name: "Shamli",
          path: "Shamli",
        },
        {
          id: 69,
          name: "shravasti",
          path: "shravasti",
        },
        {
          id: 70,
          name: "Siddharth Nagar",
          path: "SiddharthNagar",
        },
        {
          id: 71,
          name: "Sitapur",
          path: "Sitapur",
        },
        {
          id: 72,
          name: "Sonbhadra",
          path: "Sonbhadra",
        },
        {
          id: 73,
          name: "Sultanpur",
          path: "Sultanpur",
        },
        {
          id: 74,
          name: "Unnao",
          path: "Unnao",
        },
        {
          id: 75,
          name: "Varanasi",
          path: "Varanasi",
        },
      ],
    },
    {
      name: "uttarakhand",
      cities: [
        {
          id: 1,
          name: "Almora",
          path: "Almora",
        },
        {
          id: 2,
          name: "Bageshwar",
          path: "Bageshwar",
        },
        {
          id: 3,
          name: "Chamoli",
          path: "Chamoli",
        },
        {
          id: 4,
          name: "Champawat",
          path: "Champawat",
        },
        {
          id: 5,
          name: "Dehradun",
          path: "Dehradun",
        },
        {
          id: 6,
          name: "Haridwar",
          path: "Haridwar",
        },
        {
          id: 7,
          name: "Nainital",
          path: "Nainital",
        },
        {
          id: 8,
          name: "Pauri Garhwal",
          path: "PauriGarhwal",
        },
        {
          id: 9,
          name: "Pithoragarh",
          path: "Pithoragarh",
        },
        {
          id: 10,
          name: "Rudraprayag",
          path: "Rudraprayag",
        },
        {
          id: 11,
          name: "Tehri Garhwal",
          path: "TehriGarhwal",
        },
        {
          id: 12,
          name: "Udham Sing Nagar",
          path: "UdhamSingNagar",
        },
        {
          id: 13,
          name: "Uttarkashi",
          path: "Uttarkashi",
        },
      ],
    },
    {
      name: "tripura",
      cities: [
        {
          id: 1,
          name: "Dhalai",
          path: "Dhalai",
        },
        {
          id: 2,
          name: "Gomati",
          path: "Gomati",
        },
        {
          id: 3,
          name: "Khowai",
          path: "Khowai",
        },
        {
          id: 4,
          name: "North Tripura",
          path: "NorthTripura",
        },
        {
          id: 5,
          name: "Sepahijala",
          path: "Sepahijala",
        },
        {
          id: 6,
          name: "South Tripura",
          path: "SouthTripura",
        },
        {
          id: 7,
          name: "JUnokoti",
          path: "JUnokoti",
        },
        {
          id: 8,
          name: "West Tripura",
          path: "WestTripura",
        },
      ],
    },
    {
      name: "telangana",
      cities: [
        {
          id: 1,
          name: "Adilabad",
          path: "Adilabad",
        },
        {
          id: 2,
          name: "Bhadradri Kothagudem",
          path: "BhadradriKothagudem",
        },
        {
          id: 3,
          name: "Hanamkonda",
          path: "Hanamkonda",
        },
        {
          id: 4,
          name: "Hyderabad",
          path: "Hyderabad",
        },
        {
          id: 5,
          name: "Jagitial",
          path: "Jagitial",
        },
        {
          id: 6,
          name: "Jangaon",
          path: "Jangaon",
        },
        {
          id: 7,
          name: "Jayashankar Bhupalpally",
          path: "JayashankarBhupalpally",
        },
        {
          id: 8,
          name: "Jogulamba Gadwal",
          path: "JogulambaGadwal",
        },
        {
          id: 9,
          name: "Kamareddy",
          path: "Kamareddy",
        },
        {
          id: 10,
          name: "Karimnagar",
          path: "Karimnagar",
        },
        {
          id: 11,
          name: "Khammam",
          path: "Khammam",
        },
        {
          id: 12,
          name: "Kumuram Bheem",
          path: "KumuramBheem",
        },
        {
          id: 13,
          name: "Mahabubabad",
          path: "Mahabubabad",
        },
        {
          id: 14,
          name: "Mahabubnagar",
          path: "Mahabubnagar",
        },
        {
          id: 15,
          name: "Mancherial",
          path: "Mancherial",
        },
        {
          id: 16,
          name: "Medak",
          path: "Medak",
        },
        {
          id: 17,
          name: "Medchal–Malkajgiri",
          path: "MedchalMalkajgiri",
        },
        {
          id: 18,
          name: "Mulugu",
          path: "Mulugu",
        },
        {
          id: 19,
          name: "Nagarkurnool",
          path: "Nagarkurnool",
        },
        {
          id: 20,
          name: "Narayanpet",
          path: "Narayanpet",
        },
        {
          id: 21,
          name: "Nalgonda",
          path: "Nalgonda",
        },
        {
          id: 22,
          name: "Nirmal",
          path: "Nirmal",
        },
        {
          id: 23,
          name: "Nizamabad",
          path: "Nizamabad",
        },
        {
          id: 24,
          name: "Peddapalli",
          path: "Peddapalli",
        },
        {
          id: 25,
          name: "Rajanna Sircilla",
          path: "RajannaSircilla",
        },
        {
          id: 26,
          name: "Ranga Reddy",
          path: "RangaReddy",
        },
        {
          id: 27,
          name: "Sangareddy",
          path: "Sangareddy",
        },
        {
          id: 28,
          name: "Siddipet",
          path: "Siddipet",
        },
        {
          id: 29,
          name: "Suryapet",
          path: "Suryapet",
        },
        {
          id: 30,
          name: "Vikarabad",
          path: "Vikarabad",
        },
        {
          id: 31,
          name: "Wanaparthy",
          path: "Wanaparthy",
        },
        {
          id: 32,
          name: "Warangal",
          path: "Warangal",
        },
        {
          id: 33,
          name: "Yadadri Bhuvanagiri",
          path: "YadadriBhuvanagiri",
        },
      ],
    },
    {
      name: "tamil-nadu",
      cities: [
        {
          id: 1,
          name: "Ariyalur",
          path: "Ariyalur",
        },
        {
          id: 2,
          name: "Chengalpet",
          path: "Chengalpet",
        },
        {
          id: 3,
          name: "Chennai",
          path: "Chennai",
        },
        {
          id: 4,
          name: "Coimbatore",
          path: "Coimbatore",
        },
        {
          id: 5,
          name: "Cuddalore",
          path: "Cuddalore",
        },
        {
          id: 6,
          name: "Dharmapuri",
          path: "Dharmapuri",
        },
        {
          id: 7,
          name: "Dindigul",
          path: "Dindigul",
        },
        {
          id: 8,
          name: "Erode",
          path: "Erode",
        },
        {
          id: 9,
          name: "Kallakurichi",
          path: "Kallakurichi",
        },
        {
          id: 10,
          name: "Kancheepuram",
          path: "Kancheepuram",
        },
        {
          id: 11,
          name: "Karur",
          path: "Karur",
        },
        {
          id: 12,
          name: "Krishnagiri",
          path: "Krishnagiri",
        },
        {
          id: 13,
          name: "Mayiladuthurai",
          path: "Mayiladuthurai",
        },
        {
          id: 14,
          name: "Nagapattinam",
          path: "Nagapattinam",
        },
        {
          id: 15,
          name: "Kanyakumari",
          path: "Kanyakumari",
        },
        {
          id: 16,
          name: "Namakkal",
          path: "Namakkal",
        },
        {
          id: 17,
          name: "Perambalur",
          path: "Perambalur",
        },
        {
          id: 18,
          name: "Pudukottai",
          path: "Pudukottai",
        },
        {
          id: 19,
          name: "Ramanathapuram",
          path: "Ramanathapuram",
        },
        {
          id: 20,
          name: "Ranipet",
          path: "Ranipet",
        },
        {
          id: 21,
          name: "Salem",
          path: "Salem",
        },
        {
          id: 22,
          name: "Sivagangai",
          path: "Sivagangai",
        },
        {
          id: 23,
          name: "Tenkasi",
          path: "Tenkasi",
        },
        {
          id: 24,
          name: "Thanjavur",
          path: "Thanjavur",
        },
        {
          id: 25,
          name: "Theni",
          path: "Theni",
        },
        {
          id: 26,
          name: "Thiruvallur",
          path: "Thiruvallur",
        },
        {
          id: 27,
          name: "Thiruvarur",
          path: "Thiruvarur",
        },
        {
          id: 28,
          name: "Tuticorin",
          path: "Tuticorin",
        },
        {
          id: 29,
          name: "Trichirappalli",
          path: "Trichirappalli",
        },
        {
          id: 30,
          name: "Thirunelveli",
          path: "Thirunelveli",
        },
        {
          id: 31,
          name: "Tirupathur",
          path: "Tirupathur",
        },
        {
          id: 32,
          name: "Tiruppur",
          path: "Tiruppur",
        },
        {
          id: 33,
          name: "Tiruvannamalai",
          path: "Tiruvannamalai",
        },
        {
          id: 34,
          name: "The Nilgiris",
          path: "TheNilgiris",
        },
        {
          id: 35,
          name: "Vellore",
          path: "Vellore",
        },
        {
          id: 36,
          name: "Viluppuram",
          path: "Viluppuram",
        },
        {
          id: 37,
          name: "Virudhunagar",
          path: "Virudhunagar",
        },
      ],
    },
    {
      name: "sikkim",
      cities: [
        {
          id: 1,
          name: "East Sikkim",
          path: "EastSikkim",
        },
        {
          id: 2,
          name: "North Sikkim",
          path: "NorthSikkim",
        },
        {
          id: 3,
          name: "South Sikkim",
          path: "SouthSikkim",
        },
        {
          id: 4,
          name: "West Sikkim",
          path: "WestSikkim",
        },
        {
          id: 5,
          name: "Pakyong District",
          path: "PakyongDistrict",
        },
        {
          id: 6,
          name: "Soreng District",
          path: "SorengDistrict",
        },
      ],
    },
    {
      name: "rajasthan",
      cities: [
        {
          id: 1,
          name: "Ajmer",
          path: "Ajmer",
        },
        {
          id: 2,
          name: "Alwar",
          path: "Alwar",
        },
        {
          id: 3,
          name: "Banswara",
          path: "Banswara",
        },
        {
          id: 4,
          name: "Baran",
          path: "Baran",
        },
        {
          id: 5,
          name: "Barmer",
          path: "Barmer",
        },
        {
          id: 6,
          name: "Bharatpur",
          path: "Bharatpur",
        },
        {
          id: 7,
          name: "Bhilwara",
          path: "Bhilwara",
        },
        {
          id: 8,
          name: "Bikaner",
          path: "Bikaner",
        },
        {
          id: 9,
          name: "Bundi",
          path: "Bundi",
        },
        {
          id: 10,
          name: "Chittorgarh",
          path: "Chittorgarh",
        },
        {
          id: 11,
          name: "Churu",
          path: "Churu",
        },
        {
          id: 12,
          name: "Dausa",
          path: "Dausa",
        },
        {
          id: 13,
          name: "Dholpur",
          path: "Dholpur",
        },
        {
          id: 14,
          name: "Dungarpur",
          path: "Dungarpur",
        },
        {
          id: 15,
          name: "Hanumangarh",
          path: "Hanumangarh",
        },
        {
          id: 16,
          name: "Jaipur",
          path: "Jaipur",
        },
        {
          id: 17,
          name: "Jaisalmer",
          path: "Jaisalmer",
        },
        {
          id: 18,
          name: "Jalore",
          path: "Jalore",
        },
        {
          id: 19,
          name: "Jhalawar",
          path: "Jhalawar",
        },
        {
          id: 20,
          name: "Jhunjhunu",
          path: "Jhunjhunu",
        },
        {
          id: 21,
          name: "Jodhpur",
          path: "Jodhpur",
        },
        {
          id: 22,
          name: "Karauli",
          path: "Karauli",
        },
        {
          id: 23,
          name: "Kota",
          path: "Kota",
        },
        {
          id: 24,
          name: "Nagaur",
          path: "Nagaur",
        },
        {
          id: 25,
          name: "Pali",
          path: "Pali",
        },
        {
          id: 26,
          name: "Pratapgarh",
          path: "Pratapgarh",
        },
        {
          id: 27,
          name: "Rajsamand",
          path: "Rajsamand",
        },
        {
          id: 28,
          name: "Sawai Madhopur",
          path: "SawaiMadhopur",
        },
        {
          id: 29,
          name: "Sikar",
          path: "Sikar",
        },
        {
          id: 30,
          name: "Sirohi",
          path: "Sirohi",
        },
        {
          id: 31,
          name: "Sri Ganganagar",
          path: "SriGanganagar",
        },
        {
          id: 32,
          name: "Tonk",
          path: "Tonk",
        },
        {
          id: 33,
          name: "Udaipur",
          path: "Udaipur",
        },
      ],
    },
    {
      name: "punjab",
      cities: [
        {
          id: 1,
          name: "Amritsar",
          path: "Amritsar",
        },
        {
          id: 2,
          name: "Barnala",
          path: "Barnala",
        },
        {
          id: 3,
          name: "Bathinda",
          path: "Bathinda",
        },
        {
          id: 4,
          name: "Faridkot",
          path: "Faridkot",
        },
        {
          id: 5,
          name: "Fatehgarh Sahib",
          path: "FatehgarhSahib",
        },
        {
          id: 6,
          name: "Fazilka",
          path: "Fazilka",
        },
        {
          id: 7,
          name: "Ferozepur",
          path: "Ferozepur",
        },
        {
          id: 8,
          name: "Gurdaspur",
          path: "Gurdaspur",
        },
        {
          id: 9,
          name: "Hoshiarpur",
          path: "Hoshiarpur",
        },
        {
          id: 10,
          name: "Jalandhar",
          path: "Jalandhar",
        },
        {
          id: 11,
          name: "Kapurthala",
          path: "Kapurthala",
        },
        {
          id: 12,
          name: "Ludhiana",
          path: "Ludhiana",
        },
        {
          id: 13,
          name: "Mansa",
          path: "Mansa",
        },
        {
          id: 14,
          name: "Moga",
          path: "Moga",
        },
        {
          id: 15,
          name: "Muktsar",
          path: "Muktsar",
        },
        {
          id: 16,
          name: "Nawanshahr (Shahid Bhagat Singh Nagar)",
          path: "Nawanshahr",
        },
        {
          id: 17,
          name: "Pathankot",
          path: "Pathankot",
        },
        {
          id: 18,
          name: "Patiala",
          path: "Patiala",
        },
        {
          id: 19,
          name: "Rupnagar",
          path: "Rupnagar",
        },
        {
          id: 20,
          name: "Sahibzada Ajit Singh Nagar (Mohali)",
          path: "Sahibzada",
        },
        {
          id: 21,
          name: "Sangrur",
          path: "Sangrur",
        },
        {
          id: 22,
          name: "Tarn Taran",
          path: "TarnTaran",
        },
      ],
    },
    {
      name: "odisha",
      cities: [
        {
          id: 1,
          name: "Angul",
          path: "Angul",
        },
        {
          id: 2,
          name: "Balangir",
          path: "Balangir",
        },
        {
          id: 3,
          name: "Balasore",
          path: "Balasore",
        },
        {
          id: 4,
          name: "Bargarh",
          path: "Bargarh",
        },
        {
          id: 5,
          name: "Bhadrak",
          path: "Bhadrak",
        },
        {
          id: 6,
          name: "Boudh",
          path: "Boudh",
        },
        {
          id: 7,
          name: "Cuttack",
          path: "Cuttack",
        },
        {
          id: 8,
          name: "Deogarh",
          path: "Deogarh",
        },
        {
          id: 9,
          name: "Dhenkanal",
          path: "Dhenkanal",
        },
        {
          id: 10,
          name: "Gajapati",
          path: "Gajapati",
        },
        {
          id: 11,
          name: "Ganjam",
          path: "Ganjam",
        },
        {
          id: 12,
          name: "Jagatsinghapur",
          path: "Jagatsinghapur",
        },
        {
          id: 13,
          name: "Jajpur",
          path: "Jajpur",
        },
        {
          id: 14,
          name: "Jharsuguda",
          path: "Jharsuguda",
        },
        {
          id: 15,
          name: "Kalahandi",
          path: "Kalahandi",
        },
        {
          id: 16,
          name: "Kandhamal",
          path: "Kandhamal",
        },
        {
          id: 17,
          name: "Kendrapara",
          path: "Kendrapara",
        },
        {
          id: 18,
          name: "Kendujhar (Keonjhar)",
          path: "Kendujhar",
        },
        {
          id: 19,
          name: "Khordha",
          path: "Khordha",
        },
        {
          id: 20,
          name: "Koraput",
          path: "Koraput",
        },
        {
          id: 21,
          name: "Malkangiri",
          path: "Malkangiri",
        },
        {
          id: 22,
          name: "Mayurbhanj",
          path: "Mayurbhanj",
        },
        {
          id: 23,
          name: "Nabarangpur",
          path: "Nabarangpur",
        },
        {
          id: 24,
          name: "Nayagarh",
          path: "Nayagarh",
        },
        {
          id: 25,
          name: "Nuapada",
          path: "Nuapada",
        },
        {
          id: 26,
          name: "Puri",
          path: "Puri",
        },
        {
          id: 27,
          name: "Rayagada",
          path: "Rayagada",
        },
        {
          id: 28,
          name: "Sambalpur",
          path: "Sambalpur",
        },
        {
          id: 29,
          name: "Sonepur",
          path: "Sonepur",
        },
        {
          id: 30,
          name: "Sundargarh",
          path: "Sundargarh",
        },
      ],
    },
    {
      name: "nagaland",
      cities: [
        {
          id: 1,
          name: "Dimapur",
          path: "Dimapur",
        },
        {
          id: 2,
          name: "Kiphire",
          path: "Kiphire",
        },
        {
          id: 3,
          name: "Kohima",
          path: "Kohima",
        },
        {
          id: 4,
          name: "Longleng",
          path: "Longleng",
        },
        {
          id: 5,
          name: "Mokokchung",
          path: "Mokokchung",
        },
        {
          id: 6,
          name: "Mon",
          path: "Mon",
        },
        {
          id: 7,
          name: "Peren",
          path: "Peren",
        },
        {
          id: 8,
          name: "Phek",
          path: "Phek",
        },
        {
          id: 9,
          name: "Tuensang",
          path: "Tuensang",
        },
        {
          id: 10,
          name: "Wokha",
          path: "Wokha",
        },
        {
          id: 11,
          name: "Zunheboto",
          path: "Zunheboto",
        },
      ],
    },
    {
      name: "mizoram",
      cities: [
        {
          id: 1,
          name: "Aizawl",
          path: "Aizawl",
        },
        {
          id: 2,
          name: "Champhai",
          path: "Champhai",
        },
        {
          id: 3,
          name: "Kolasib",
          path: "Kolasib",
        },
        {
          id: 4,
          name: "Lawngtlai",
          path: "Lawngtlai",
        },
        {
          id: 5,
          name: "Lunglei",
          path: "Lunglei",
        },
        {
          id: 6,
          name: "Mamit",
          path: "Mamit",
        },
        {
          id: 7,
          name: "Saiha",
          path: "Saiha",
        },
        {
          id: 8,
          name: "Serchhip",
          path: "Serchhip",
        },
      ],
    },
    {
      name: "meghalaya",
      cities: [
        {
          id: 1,
          name: "East Garo Hills",
          path: "EastGaroHills",
        },
        {
          id: 2,
          name: "East Jaintia Hills",
          path: "EastJaintiaHills",
        },
        {
          id: 3,
          name: "East Khasi Hills",
          path: "EastKhasiHills",
        },
        {
          id: 4,
          name: "North Garo Hills",
          path: "NorthGaroHills",
        },
        {
          id: 5,
          name: "Ri Bhoi",
          path: "RiBhoi",
        },
        {
          id: 6,
          name: "South Garo Hills",
          path: "SouthGaroHills",
        },
        {
          id: 7,
          name: "South West Garo Hills",
          path: "SouthWestGaroHills",
        },
        {
          id: 8,
          name: "South West Khasi Hills",
          path: "SouthWestKhasiHills",
        },
        {
          id: 9,
          name: "West Garo Hills",
          path: "WestGaroHills",
        },
        {
          id: 10,
          name: "West Jaintia Hills",
          path: "WestJaintiaHills",
        },
        {
          id: 11,
          name: "West Khasi Hills",
          path: "WestKhasiHills",
        },
      ],
    },
    {
      name: "manipur",
      cities: [
        {
          id: 1,
          name: "Bishnupur",
          path: "Bishnupur",
        },
        {
          id: 2,
          name: "Chandel",
          path: "Chandel",
        },
        {
          id: 3,
          name: "Churachandpur",
          path: "Churachandpur",
        },
        {
          id: 4,
          name: "Imphal East",
          path: "ImphalEast",
        },
        {
          id: 5,
          name: "Imphal West",
          path: "ImphalWest",
        },
        {
          id: 6,
          name: "Jiribam",
          path: "Jiribam",
        },
        {
          id: 7,
          name: "Kakching",
          path: "Kakching",
        },
        {
          id: 8,
          name: "Kamjong",
          path: "Kamjong",
        },
        {
          id: 9,
          name: "Kangpokpi",
          path: "Kangpokpi",
        },
        {
          id: 10,
          name: "Noney",
          path: "Noney",
        },
        {
          id: 11,
          name: "Pherzawl",
          path: "Pherzawl",
        },
        {
          id: 12,
          name: "Senapati",
          path: "Senapati",
        },
        {
          id: 13,
          name: "Tamenglong",
          path: "Tamenglong",
        },
        {
          id: 14,
          name: "Tengnoupal",
          path: "Tengnoupal",
        },
        {
          id: 15,
          name: "Thoubal",
          path: "Thoubal",
        },
        {
          id: 16,
          name: "Ukhrul",
          path: "Ukhrul",
        },
      ],
    },
    {
      name: "maharastra",
      cities: [
        {
          id: 1,
          name: "Ahmednagar",
          path: "Ahmednagar",
        },
        {
          id: 2,
          name: "Akola",
          path: "Akola",
        },
        {
          id: 3,
          name: "Amravati",
          path: "Amravati",
        },
        {
          id: 4,
          name: "Aurangabad",
          path: "Aurangabad",
        },
        {
          id: 5,
          name: "Beed",
          path: "Beed",
        },
        {
          id: 6,
          name: "Bhandara",
          path: "Bhandara",
        },
        {
          id: 7,
          name: "Buldhana",
          path: "Buldhana",
        },
        {
          id: 8,
          name: "Chandrapur",
          path: "Chandrapur",
        },
        {
          id: 9,
          name: "Dhule",
          path: "Dhule",
        },
        {
          id: 10,
          name: "Gadchiroli",
          path: "Gadchiroli",
        },
        {
          id: 11,
          name: "Gondia",
          path: "Gondia",
        },
        {
          id: 12,
          name: "Hingoli",
          path: "Hingoli",
        },
        {
          id: 13,
          name: "Jalgaon",
          path: "Jalgaon",
        },
        {
          id: 14,
          name: "Jalna",
          path: "Jalna",
        },
        {
          id: 15,
          name: "Kolhapur",
          path: "Kolhapur",
        },
        {
          id: 16,
          name: "Latur",
          path: "Latur",
        },
        {
          id: 17,
          name: "Mumbai City",
          path: "MumbaiCity",
        },
        {
          id: 18,
          name: "Mumbai Suburban",
          path: "MumbaiSuburban",
        },
        {
          id: 19,
          name: "Nagpur",
          path: "Nagpur",
        },
        {
          id: 20,
          name: "Nanded",
          path: "Nanded",
        },
        {
          id: 21,
          name: "Nandurbar",
          path: "Nandurbar",
        },
        {
          id: 22,
          name: "Nashik",
          path: "Nashik",
        },
        {
          id: 23,
          name: "Osmanabad",
          path: "Osmanabad",
        },
        {
          id: 24,
          name: "Palghar",
          path: "Palghar",
        },
        {
          id: 25,
          name: "Parbhani",
          path: "Parbhani",
        },
        {
          id: 26,
          name: "Pune",
          path: "Pune",
        },
        {
          id: 27,
          name: "Raigad",
          path: "Raigad",
        },
        {
          id: 28,
          name: "Ratnagiri",
          path: "Ratnagiri",
        },
        {
          id: 29,
          name: "Sangli",
          path: "Sangli",
        },
        {
          id: 30,
          name: "Satara",
          path: "Satara",
        },
        {
          id: 31,
          name: "Sindhudurg",
          path: "Sindhudurg",
        },
        {
          id: 32,
          name: "Solapur",
          path: "Solapur",
        },
        {
          id: 33,
          name: "Thane",
          path: "Thane",
        },
        {
          id: 34,
          name: "Washim",
          path: "Washim",
        },
        {
          id: 35,
          name: "Wardha",
          path: "Wardha",
        },
        {
          id: 36,
          name: "Yavatmal",
          path: "Yavatmal",
        },
      ],
    },
    {
      name: "madhya-pradesh",
      cities: [
        {
          id: 1,
          name: "Agar Malwa",
          path: "AgarMalwa",
        },
        {
          id: 2,
          name: "Alirajpur",
          path: "Alirajpur",
        },
        {
          id: 3,
          name: "Anuppur",
          path: "Anuppur",
        },
        {
          id: 4,
          name: "Ashoknagar",
          path: "Ashoknagar",
        },
        {
          id: 5,
          name: "Balaghat",
          path: "Balaghat",
        },
        {
          id: 6,
          name: "Barwani",
          path: "Barwani",
        },
        {
          id: 7,
          name: "Betul",
          path: "Betul",
        },
        {
          id: 8,
          name: "Bhind",
          path: "Bhind",
        },
        {
          id: 9,
          name: "Bhopal",
          path: "Bhopal",
        },
        {
          id: 10,
          name: "Burhanpur",
          path: "Burhanpur",
        },
        {
          id: 11,
          name: "Chhatarpur",
          path: "Chhatarpur",
        },
        {
          id: 12,
          name: "Chhindwara",
          path: "Chhindwara",
        },
        {
          id: 13,
          name: "Damoh",
          path: "Damoh",
        },
        {
          id: 14,
          name: "Datia",
          path: "Datia",
        },
        {
          id: 15,
          name: "Dewas",
          path: "Dewas",
        },
        {
          id: 16,
          name: "Dhar",
          path: "Dhar",
        },
        {
          id: 17,
          name: "Dindori",
          path: "Dindori",
        },
        {
          id: 18,
          name: "Guna",
          path: "Guna",
        },
        {
          id: 19,
          name: "Gwalior",
          path: "Gwalior",
        },
        {
          id: 20,
          name: "Harda",
          path: "Harda",
        },
        {
          id: 21,
          name: "Hoshangabad",
          path: "Hoshangabad",
        },
        {
          id: 22,
          name: "Indore",
          path: "Indore",
        },
        {
          id: 23,
          name: "Jabalpur",
          path: "Jabalpur",
        },
        {
          id: 24,
          name: "Jhabua",
          path: "Jhabua",
        },
        {
          id: 25,
          name: "Katni",
          path: "Katni",
        },
        {
          id: 26,
          name: "Khandwa",
          path: "Khandwa",
        },
        {
          id: 27,
          name: "Khargone",
          path: "Khargone",
        },
        {
          id: 28,
          name: "Mandla",
          path: "Mandla",
        },
        {
          id: 29,
          name: "Mandsaur",
          path: "Mandsaur",
        },
        {
          id: 30,
          name: "Morena",
          path: "Morena",
        },
        {
          id: 31,
          name: "Narsinghpur",
          path: "Narsinghpur",
        },
        {
          id: 32,
          name: "Neemuch",
          path: "Neemuch",
        },
        {
          id: 33,
          name: "Panna",
          path: "Panna",
        },
        {
          id: 34,
          name: "Raisen",
          path: "Raisen",
        },
        {
          id: 35,
          name: "Rajgarh",
          path: "Rajgarh",
        },
        {
          id: 36,
          name: "Ratlam",
          path: "Ratlam",
        },
        {
          id: 37,
          name: "Sagar",
          path: "Sagar",
        },
        {
          id: 38,
          name: "Satna",
          path: "Satna",
        },
        {
          id: 39,
          name: "Sehore",
          path: "Sehore",
        },
        {
          id: 40,
          name: "Seoni",
          path: "Seoni",
        },
        {
          id: 41,
          name: "Shahdol",
          path: "Shahdol",
        },
        {
          id: 42,
          name: "Shajapur",
          path: "Shajapur",
        },
        {
          id: 43,
          name: "Sheopur",
          path: "Sheopur",
        },
        {
          id: 44,
          name: "Shivpuri",
          path: "Shivpuri",
        },
        {
          id: 45,
          name: "Sidhi",
          path: "Sidhi",
        },
        {
          id: 46,
          name: "Singrauli",
          path: "Singrauli",
        },
        {
          id: 47,
          name: "Tikamgarh",
          path: "Tikamgarh",
        },
        {
          id: 48,
          name: "Ujjain",
          path: "Ujjain",
        },
        {
          id: 49,
          name: "Umaria",
          path: "Umaria",
        },
        {
          id: 50,
          name: "Vidisha",
          path: "Vidisha",
        },
      ],
    },
    {
      name: "kerala",
      cities: [
        {
          id: 1,
          name: "Alappuzha",
          path: "Alappuzha",
        },
        {
          id: 2,
          name: "Ernakulam",
          path: "Ernakulam",
        },
        {
          id: 3,
          name: "Idukki",
          path: "Idukki",
        },
        {
          id: 4,
          name: "Kannur",
          path: "Kannur",
        },
        {
          id: 5,
          name: "Kasaragod",
          path: "Kasaragod",
        },
        {
          id: 6,
          name: "Kollam",
          path: "Kollam",
        },
        {
          id: 7,
          name: "Kottayam",
          path: "Kottayam",
        },
        {
          id: 8,
          name: "Kozhikode",
          path: "Kozhikode",
        },
        {
          id: 9,
          name: "Malappuram",
          path: "Malappuram",
        },
        {
          id: 10,
          name: "Palakkad",
          path: "Palakkad",
        },
        {
          id: 11,
          name: "Pathanamthitta",
          path: "Pathanamthitta",
        },
        {
          id: 12,
          name: "Thiruvananthapuram",
          path: "Thiruvananthapuram",
        },
        {
          id: 13,
          name: "Thrissur",
          path: "Thrissur",
        },
        {
          id: 14,
          name: "Wayanad",
          path: "Wayanad",
        },
      ],
    },
    {
      name: "Karnataka",
      cities: [
        {
          id: 1,
          name: "Bagalkot",
          path: "Bagalkot",
        },
        {
          id: 2,
          name: "Ballari (Bellary)",
          path: "Ballari",
        },
        {
          id: 3,
          name: "Belagavi (Belgaum)",
          path: "Belagavi",
        },
        {
          id: 4,
          name: "Bengaluru (Bangalore) Rural",
          path: "BangloreRural",
        },
        {
          id: 5,
          name: "Bengaluru (Bangalore) Urban",
          path: "BangloreUrban",
        },
        {
          id: 6,
          name: "Bidar",
          path: "Bidar",
        },
        {
          id: 7,
          name: "Chamarajanagar",
          path: "Chamarajanagar",
        },
        {
          id: 8,
          name: "Chikballapur",
          path: "Chikballapur",
        },
        {
          id: 9,
          name: "Chikkamagaluru (Chikmagalur)",
          path: "Chikkamagaluru",
        },
        {
          id: 10,
          name: "Chitradurga",
          path: "Chitradurga",
        },
        {
          id: 11,
          name: "Dakshina Kannada",
          path: "Dakshina Kannada",
        },
        {
          id: 12,
          name: "Davangere",
          path: "Davanagere",
        },
        {
          id: 13,
          name: "Dharwad",
          path: "Dharwad",
        },
        {
          id: 14,
          name: "Gadag",
          path: "Gadag",
        },
        {
          id: 15,
          name: "Hassan",
          path: "Hassana",
        },
        {
          id: 16,
          name: "Haveri",
          path: "Haveri",
        },
        {
          id: 17,
          name: "Kalaburagi (Gulbarga)",
          path: "Kalaburagi",
        },
        {
          id: 18,
          name: "Kodagu",
          path: "Kodagu",
        },
        {
          id: 19,
          name: "Kolar",
          path: "Kolar",
        },
        {
          id: 20,
          name: "Koppal",
          path: "Koppal",
        },
        {
          id: 21,
          name: "Mandya",
          path: "Mandya",
        },
        {
          id: 22,
          name: "Mysuru (Mysore)",
          path: "Mysuru",
        },
        {
          id: 23,
          name: "Raichur",
          path: "Raichuru",
        },
        {
          id: 24,
          name: "Ramanagara",
          path: "Ramanagara",
        },
        {
          id: 25,
          name: "Shivamogga (Shimoga)",
          path: "Shimoga",
        },
        {
          id: 26,
          name: "Tumakuru (Tumkur)",
          path: "Tumakuru",
        },
        {
          id: 27,
          name: "Udupi",
          path: "Udupi",
        },
        {
          id: 28,
          name: "Uttara Kannada (Karwar)",
          path: "UttarKannada",
        },
        {
          id: 29,
          name: "Vijayapura (Bijapur)",
          path: "Bijapur",
        },
        {
          id: 30,
          name: "Yadgir",
          path: "Yadgir",
        },
      ],
    },
    {
      name: "jharkhand",
      cities: [
        {
          id: 1,
          name: "Bokaro",
          path: "Bokaro",
        },
        {
          id: 2,
          name: "Chatra",
          path: "Chatra",
        },
        {
          id: 3,
          name: "Deoghar",
          path: "Deoghar",
        },
        {
          id: 4,
          name: "Dhanbad",
          path: "Dhanbad",
        },
        {
          id: 5,
          name: "Dumka",
          path: "Dumka",
        },
        {
          id: 6,
          name: "East Singhbhum",
          path: "EastSinghbhum",
        },
        {
          id: 7,
          name: "Garhwa",
          path: "Garhwa",
        },
        {
          id: 8,
          name: "West Singhbhum",
          path: "WestSinghbhum",
        },
        {
          id: 9,
          name: "Giridih",
          path: "Giridih",
        },
        {
          id: 10,
          name: "Godda",
          path: "Godda",
        },
        {
          id: 11,
          name: "Gumla",
          path: "Gumla",
        },
        {
          id: 12,
          name: "Hazaribag",
          path: "Hazaribag",
        },
        {
          id: 13,
          name: "Jamtara",
          path: "Jamtara",
        },
        {
          id: 14,
          name: "Khunti",
          path: "Khunti",
        },
        {
          id: 15,
          name: "Koderma",
          path: "Koderma",
        },
        {
          id: 16,
          name: "Latehar",
          path: "Latehar",
        },
        {
          id: 17,
          name: "Lohardaga",
          path: "Lohardaga",
        },
        {
          id: 18,
          name: "Pakur",
          path: "Pakur",
        },
        {
          id: 19,
          name: "Palamu",
          path: "Palamu",
        },
        {
          id: 20,
          name: "Ramgarh",
          path: "Ramgarh",
        },
        {
          id: 21,
          name: "Ranchi",
          path: "Ranchi",
        },
        {
          id: 22,
          name: "Sahibganj",
          path: "Sahibganj",
        },
        {
          id: 23,
          name: "Seraikela-Kharsawan",
          path: "SeraikelaKharsawan",
        },
        {
          id: 24,
          name: "Simdega",
          path: "Simdega",
        },
      ],
    },
    {
      name: "himachal-pradesh",
      cities: [
        {
          id: 1,
          name: "Bilaspur",
          path: "Bilaspur",
        },
        {
          id: 2,
          name: "Chamba",
          path: "Chamba",
        },
        {
          id: 3,
          name: "Hamirpur",
          path: "Hamirpur",
        },
        {
          id: 4,
          name: "Kangra",
          path: "Kangra",
        },
        {
          id: 5,
          name: "Kinnaur",
          path: "Kinnaur",
        },
        {
          id: 6,
          name: "Kullu",
          path: "Kullu",
        },
        {
          id: 7,
          name: "Lahaul & Spiti",
          path: "Lahaul&Spiti",
        },
        {
          id: 8,
          name: "Mandi",
          path: "Mandi",
        },
        {
          id: 9,
          name: "Shimla",
          path: "Shimla",
        },
        {
          id: 10,
          name: "Sirmaur (Sirmour)",
          path: "Sirmaur",
        },
        {
          id: 11,
          name: "Solan",
          path: "Solan",
        },
        {
          id: 12,
          name: "Una",
          path: "Una",
        },
      ],
    },
    {
      name: "haryana",
      cities: [
        {
          id: 1,
          name: "Ambala",
          path: "Ambala",
        },
        {
          id: 2,
          name: "Bhiwani",
          path: "Bhiwani",
        },
        {
          id: 3,
          name: "Charkhi Dadri",
          path: "CharkhiDadri",
        },
        {
          id: 4,
          name: "Faridabad",
          path: "Faridabad",
        },
        {
          id: 5,
          name: "Fatehabad",
          path: "Fatehabad",
        },
        {
          id: 6,
          name: "Gurugram (Gurgaon)",
          path: "Gurugram",
        },
        {
          id: 7,
          name: "Hisar",
          path: "Hisar",
        },
        {
          id: 8,
          name: "Jhajjar",
          path: "Jhajjar",
        },
        {
          id: 9,
          name: "Jind",
          path: "Jind",
        },
        {
          id: 10,
          name: "Kaithal",
          path: "Kaithal",
        },
        {
          id: 11,
          name: "Karnal",
          path: "Karnal",
        },
        {
          id: 12,
          name: "Kurukshetra",
          path: "Kurukshetra",
        },
        {
          id: 13,
          name: "Mahendragarh",
          path: "Mahendragarh",
        },
        {
          id: 14,
          name: "Nuh",
          path: "Nuh",
        },
        {
          id: 15,
          name: "Palwal",
          path: "Palwal",
        },
        {
          id: 16,
          name: "Panchkula",
          path: "Panchkula",
        },
        {
          id: 17,
          name: "Panipat",
          path: "Panipat",
        },
        {
          id: 18,
          name: "Rewari",
          path: "Rewari",
        },
        {
          id: 19,
          name: "Rohtak",
          path: "Rohtak",
        },
        {
          id: 20,
          name: "Sirsa",
          path: "Sirsa",
        },
        {
          id: 21,
          name: "Sonipat",
          path: "Sonipat",
        },
        {
          id: 22,
          name: "Yamunanagar",
          path: "Yamunanagar",
        },
      ],
    },
    {
      name: "gujrat",
      cities: [
        {
          id: 1,
          name: "Ahmedabad",
          path: "Ahmedabad",
        },
        {
          id: 2,
          name: "Amreli",
          path: "Amreli",
        },
        {
          id: 3,
          name: "Anand",
          path: "Anand",
        },
        {
          id: 4,
          name: "Aravalli",
          path: "Aravalli",
        },
        {
          id: 5,
          name: "Banaskantha (Palanpur)",
          path: "Banaskantha",
        },
        {
          id: 6,
          name: "Bharuch",
          path: "Bharuch",
        },
        {
          id: 7,
          name: "Bhavnagar",
          path: "Bhavnagar",
        },
        {
          id: 8,
          name: "Botad",
          path: "Botad",
        },
        {
          id: 9,
          name: "Chhota Udepur",
          path: "ChhotaUdepur",
        },
        {
          id: 10,
          name: "Dahod",
          path: "Dahod",
        },
        {
          id: 11,
          name: "Dangs (Ahwa)",
          path: "Dangs",
        },
        {
          id: 12,
          name: "Devbhoomi Dwarka",
          path: "DevbhoomiDwarka",
        },
        {
          id: 13,
          name: "Gandhinagar",
          path: "Gandhinagar",
        },
        {
          id: 14,
          name: "Gir Somnath",
          path: "GirSomnath",
        },
        {
          id: 15,
          name: "Jamnagar",
          path: "Jamnagar",
        },
        {
          id: 16,
          name: "Junagadh",
          path: "Junagadh",
        },
        {
          id: 17,
          name: "Kachchh",
          path: "Kachchh",
        },
        {
          id: 18,
          name: "Kheda (Nadiad)",
          path: "Kheda",
        },
        {
          id: 19,
          name: "Mahisagar",
          path: "Mahisagar",
        },
        {
          id: 20,
          name: "Mehsana",
          path: "Mehsana",
        },
        {
          id: 21,
          name: "Morbi",
          path: "Morbi",
        },
        {
          id: 22,
          name: "Narmada (Rajpipla)",
          path: "Narmada",
        },
        {
          id: 23,
          name: "Navsari",
          path: "Navsari",
        },
        {
          id: 24,
          name: "Panchmahal (Godhra)",
          path: "Panchmahal",
        },
        {
          id: 25,
          name: "Patan",
          path: "Patan",
        },
        {
          id: 26,
          name: "Porbandar",
          path: "Porbandar",
        },
        {
          id: 27,
          name: "Rajkot",
          path: "Rajkot",
        },
        {
          id: 28,
          name: "Sabarkantha (Himmatnagar)",
          path: "Sabarkantha",
        },
        {
          id: 29,
          name: "Surat",
          path: "Surat",
        },
        {
          id: 30,
          name: "Surendranagar",
          path: "Surendranagar",
        },
        {
          id: 31,
          name: "Tapi (Vyara)",
          path: "Tapi",
        },
        {
          id: 32,
          name: "Vadodara",
          path: "Vadodara",
        },
        {
          id: 33,
          name: "Valsad",
          path: "Valsad",
        },
      ],
    },
    {
      name: "goa",
      cities: [
        {
          id: 1,
          name: "North Goa",
          path: "NorthGoa",
        },
        {
          id: 2,
          name: "South Goa",
          path: "SouthGoa",
        },
      ],
    },
    {
      name: "delhi",
      cities: [
        {
          id: 1,
          name: "Central Delhi",
          path: "CentralDelhi",
        },
        {
          id: 2,
          name: "East Delhi",
          path: "EastDelhi",
        },
        {
          id: 3,
          name: "New Delhi",
          path: "NewDelhi",
        },
        {
          id: 4,
          name: "North Delhi",
          path: "NorthDelhi",
        },
        {
          id: 5,
          name: "North West Delhi",
          path: "NorthWestDelhi",
        },
        {
          id: 6,
          name: "South Delhi",
          path: "SouthDelhi",
        },
        {
          id: 7,
          name: "South West delhi",
          path: "SouthWestdelhi",
        },
        {
          id: 8,
          name: "West Delhi",
          path: "WestDelhi",
        },
      ],
    },
    {
      name: "chattisgarh",
      cities: [
        {
          id: 1,
          name: "Balod",
          path: "Balod",
        },
        {
          id: 2,
          name: "Baloda Bazar",
          path: "BalodaBazar",
        },
        {
          id: 3,
          name: "Balrampur",
          path: "Balrampur",
        },
        {
          id: 4,
          name: "Bastar",
          path: "Bastar",
        },
        {
          id: 5,
          name: "Bemetara",
          path: "Bemetara",
        },
        {
          id: 6,
          name: "Bijapur",
          path: "Bijapur",
        },
        {
          id: 7,
          name: "Bilaspur",
          path: "Bilaspur",
        },
        {
          id: 8,
          name: "Dantewada (South Bastar)",
          path: "Dantewada",
        },
        {
          id: 9,
          name: "Dhamtari",
          path: "Dhamtari",
        },
        {
          id: 10,
          name: "Durg",
          path: "Durg",
        },
        {
          id: 11,
          name: "Gariyaband",
          path: "Gariyaband",
        },
        {
          id: 12,
          name: "Janjgir Champa",
          path: "JanjgirChampa",
        },
        {
          id: 13,
          name: "Jashpur",
          path: "Jashpur",
        },
        {
          id: 14,
          name: "Kabirdham (Kawardha)",
          path: "Kabirdham",
        },
        {
          id: 15,
          name: "Kanker (North Bastar)",
          path: "Kanker",
        },
        {
          id: 16,
          name: "Kondagaon",
          path: "Kondagaon",
        },
        {
          id: 17,
          name: "Korba",
          path: "Korba",
        },
        {
          id: 18,
          name: "Korea (Koriya)",
          path: "Korea",
        },
        {
          id: 19,
          name: "Mahasamund",
          path: "Mahasamund",
        },
        {
          id: 20,
          name: "Mungeli",
          path: "Mungeli",
        },
        {
          id: 21,
          name: "Narayanpur",
          path: "Narayanpur",
        },
        {
          id: 22,
          name: "Raigarh",
          path: "Raigarh",
        },
        {
          id: 23,
          name: "Raipur",
          path: "Raipur",
        },
        {
          id: 24,
          name: "Rajnandgaon",
          path: "Rajnandgaon",
        },
        {
          id: 25,
          name: "Sukma",
          path: "Sukma",
        },
        {
          id: 26,
          name: "Surajpur",
          path: "Surajpur",
        },
        {
          id: 27,
          name: "Surguja",
          path: "Surguja",
        },
      ],
    },
    {
      name: "bihar",
      cities: [
        {
          id: 1,
          name: "Araria",
          path: "Araria",
        },
        {
          id: 2,
          name: "Arwal",
          path: "Arwal",
        },
        {
          id: 3,
          name: "Aurangabad",
          path: "Aurangabad",
        },
        {
          id: 4,
          name: "Banka",
          path: "Banka",
        },
        {
          id: 5,
          name: "Begusarai",
          path: "Begusarai",
        },
        {
          id: 6,
          name: "Bhagalpur",
          path: "Bhagalpur",
        },
        {
          id: 7,
          name: "Bhojpur",
          path: "Bhojpur",
        },
        {
          id: 8,
          name: "Buxar",
          path: "Buxar",
        },
        {
          id: 9,
          name: "Darbhanga",
          path: "Darbhanga",
        },
        {
          id: 10,
          name: "East Champaran (Motihari)",
          path: "EastChamparan",
        },
        {
          id: 11,
          name: "Gaya",
          path: "Gaya",
        },
        {
          id: 12,
          name: "Gopalganj",
          path: "Gopalganj",
        },
        {
          id: 13,
          name: "Jamui",
          path: "Jamui",
        },
        {
          id: 14,
          name: "Jehanabad",
          path: "Jehanabad",
        },
        {
          id: 15,
          name: "Kaimur (Bhabua)",
          path: "Kaimur",
        },
        {
          id: 16,
          name: "Katihar",
          path: "Katihar",
        },
        {
          id: 17,
          name: "Jorhat",
          path: "Jorhat",
        },
        {
          id: 18,
          name: "Kamrup",
          path: "Kamrup",
        },
        {
          id: 19,
          name: "Khagaria",
          path: "Khagaria",
        },
        {
          id: 20,
          name: "Kishanganj",
          path: "Kishanganj",
        },
        {
          id: 21,
          name: "Lakhisarai",
          path: "Lakhisarai",
        },
        {
          id: 22,
          name: "Madhepura",
          path: "Madhepura",
        },
        {
          id: 23,
          name: "Madhubani",
          path: "Madhubani",
        },
        {
          id: 24,
          name: "Munger (Monghyr)",
          path: "Munger",
        },
        {
          id: 25,
          name: "Muzaffarpur",
          path: "Muzaffarpur",
        },
        {
          id: 26,
          name: "Nalanda",
          path: "Nalanda",
        },
        {
          id: 27,
          name: "Nawada",
          path: "Nawada",
        },
        {
          id: 28,
          name: "Patna",
          path: "Patna",
        },
        {
          id: 29,
          name: "Purnia (Purnea)",
          path: "Purnia",
        },
        {
          id: 30,
          name: "Rohtas",
          path: "Rohtas",
        },
        {
          id: 31,
          name: "Saharsa",
          path: "Saharsa",
        },
        {
          id: 32,
          name: "Samastipur",
          path: "Samastipur",
        },
        {
          id: 33,
          name: "Saran",
          path: "Saran",
        },
        {
          id: 34,
          name: "Sheikhpura",
          path: "Sheikhpura",
        },
        {
          id: 35,
          name: "Sheohar",
          path: "Sheohar",
        },
        {
          id: 36,
          name: "Sitamarhi",
          path: "Sitamarhi",
        },
        {
          id: 37,
          name: "Siwan",
          path: "Siwan",
        },
        {
          id: 38,
          name: "Supaul",
          path: "Supaul",
        },
        {
          id: 39,
          name: "Vaishali",
          path: "Vaishali",
        },
        {
          id: 40,
          name: "West Champaran",
          path: "WestChamparan",
        },
      ],
    },
    {
      name: "assam",
      cities: [
        {
          id: 1,
          name: "Baksa",
          path: "Baksa",
        },
        {
          id: 2,
          name: "Barpeta",
          path: "Barpeta",
        },
        {
          id: 3,
          name: "Biswanath",
          path: "Biswanath",
        },
        {
          id: 4,
          name: "Bongaigaon",
          path: "Bongaigaon",
        },
        {
          id: 5,
          name: "Cachar",
          path: "Cachar",
        },
        {
          id: 6,
          name: "Charaideo",
          path: "Charaideo",
        },
        {
          id: 7,
          name: "Chirang",
          path: "Chirang",
        },
        {
          id: 8,
          name: "Darrang",
          path: "Darrang",
        },
        {
          id: 9,
          name: "Dhemaji",
          path: "Dhemaji",
        },
        {
          id: 10,
          name: "Dhubri",
          path: "Dhubri",
        },
        {
          id: 11,
          name: "Dibrugarh",
          path: "Dibrugarh",
        },
        {
          id: 12,
          name: "Dima Hasao (North Cachar Hills)",
          path: "DimaHasao",
        },
        {
          id: 13,
          name: "Goalpara",
          path: "Goalpara",
        },
        {
          id: 14,
          name: "Golaghat",
          path: "Golaghat",
        },
        {
          id: 15,
          name: "Hailakandi",
          path: "Hailakandi",
        },
        {
          id: 16,
          name: "Hojai",
          path: "Hojai",
        },
        {
          id: 17,
          name: "Jorhat",
          path: "Jorhat",
        },
        {
          id: 18,
          name: "Kamrup",
          path: "Kamrup",
        },
        {
          id: 19,
          name: "Kamrup Metropolitan",
          path: "KamrupMetropolitan",
        },
        {
          id: 20,
          name: "Karbi Anglong",
          path: "KarbiAnglong",
        },
        {
          id: 21,
          name: "Karimganj",
          path: "Karimganj",
        },
        {
          id: 22,
          name: "Kokrajhar",
          path: "Kokrajhar",
        },
        {
          id: 23,
          name: "Lakhimpur",
          path: "Lakhimpur",
        },
        {
          id: 24,
          name: "Majuli",
          path: "Majuli",
        },
        {
          id: 25,
          name: "Morigaon",
          path: "Morigaon",
        },
        {
          id: 26,
          name: "Nagaon",
          path: "Nagaon",
        },
        {
          id: 27,
          name: "Nalbari",
          path: "Nalbari",
        },
        {
          id: 28,
          name: "Sivasagar",
          path: "Sivasagar",
        },
        {
          id: 29,
          name: "Sonitpur",
          path: "Sonitpur",
        },
        {
          id: 30,
          name: "South Salamara-Mankachar",
          path: "SouthSalamaraMankachar",
        },
        {
          id: 31,
          name: "Udalguri",
          path: "Udalguri",
        },
        {
          id: 32,
          name: "West Karbi Anglong",
          path: "WestKarbiAnglong",
        },
      ],
    },
    {
      name: "arunachal-pradesh",
      cities: [
        {
          id: 1,
          name: "Anjaw",
          path: "Anjaw",
        },
        {
          id: 2,
          name: "Changlang",
          path: "Changlang",
        },
        {
          id: 3,
          name: "Dibang Valley",
          path: "DibangValley",
        },
        {
          id: 4,
          name: "East Kameng",
          path: "EastKameng",
        },
        {
          id: 5,
          name: "East Siang",
          path: "EastSiang",
        },
        {
          id: 6,
          name: "Kurung Kumey",
          path: "KurungKumey",
        },
        {
          id: 7,
          name: "Lohit",
          path: "Lohit",
        },
        {
          id: 8,
          name: "Lower Dibang Valley",
          path: "LowerDibangValley",
        },
        {
          id: 9,
          name: "Lower Subansiri",
          path: "LowerSubansiri",
        },
        {
          id: 10,
          name: "Papum Pare",
          path: "PapumPare",
        },
        {
          id: 11,
          name: "Tawang",
          path: "Tawang",
        },
        {
          id: 12,
          name: "Tirap",
          path: "Tirap",
        },
        {
          id: 13,
          name: "Upper Siang",
          path: "UpperSiang",
        },
        {
          id: 14,
          name: "Upper Subansiri",
          path: "UpperSubansiri",
        },
        {
          id: 15,
          name: "West Kameng",
          path: "WestKameng",
        },
        {
          id: 16,
          name: "West Siang",
          path: "WestSiang",
        },
      ],
    },
    {
      name: "andhra-pradesh",
      cities: [
        {
          id: 1,
          name: "Rangareddy",
          path: "Rangareddy",
        },
        {
          id: 2,
          name: "East Godavari",
          path: "EastGodavari",
        },
        {
          id: 3,
          name: "Guntur",
          path: "Guntur",
        },
        {
          id: 4,
          name: "Krishna",
          path: "Krishna",
        },
        {
          id: 5,
          name: "Visakhapatnam",
          path: "Visakhapatnam",
        },
        {
          id: 6,
          name: "Chittoor",
          path: "Chittoor",
        },
        {
          id: 7,
          name: "Anantapur",
          path: "Anantapur",
        },
        {
          id: 8,
          name: "Kurnool",
          path: "Kurnool",
        },
        {
          id: 9,
          name: "Mahbubnagar",
          path: "Mahbubnagar",
        },
        {
          id: 10,
          name: "Hyderabad",
          path: "Hyderabad",
        },
        {
          id: 11,
          name: "Vizianagaram",
          path: "Vizianagaram",
        },
        {
          id: 12,
          name: "West Godavari",
          path: "WestGodavari",
        },
        {
          id: 13,
          name: "Karimnagar",
          path: "Karimnagar",
        },
        {
          id: 14,
          name: "Warangal",
          path: "Warangal",
        },
        {
          id: 15,
          name: "Nalgonda",
          path: "Nalgonda",
        },
        {
          id: 16,
          name: "Prakasam",
          path: "Prakasam",
        },
        {
          id: 17,
          name: "Medak",
          path: "Medak",
        },
        {
          id: 18,
          name: "Sri Potti Sriramulu Nellore",
          path: "SriPottiSriramuluNellore",
        },
        {
          id: 19,
          name: "YSR",
          path: "YSR",
        },
        {
          id: 20,
          name: "Khammam",
          path: "Khammam",
        },
        {
          id: 21,
          name: "Adilabad",
          path: "Adilabad",
        },
        {
          id: 22,
          name: "Srikakulam",
          path: "Srikakulam",
        },
        {
          id: 23,
          name: "Nizamabad",
          path: "Nizamabadu",
        },
      ],
    },
  ];

  useEffect(() => {
    district.map((val) => {
      if (id === val.name) {
        setDistValue(val.cities);
        setSearchData(val.cities)
      }
    });
    axios
      .get(
        `${Baseurl.baseurl}/go-pincode/get-districts/${localStorage.getItem("sname")}`
      )
      .then((response) => {
        let distnames = [];
        response.data.districts.map((val) => {
          distnames.push(val.Name);
        });
        setDistNames(distnames);
      })
      .catch((err) =>{});
  }, []);
  const searchFunction=(value)=>{
    let filteredData = [];
    searchData.map((val) => {
      if (
        val.name.toLowerCase().includes(value) 
      ) {
        filteredData.push(val);
      }
    });
    setDistValue(filteredData);
  }
  const gname = (g) => {
    localStorage.setItem("gname", g);
  };
  useEffect(() => {
    setData(document.querySelectorAll("#myTable tbody tr"));
    chackboxFun();
  }, []);

  const chackbox = document.querySelectorAll(".sorting_1 input");
  const motherChackBox = document.querySelector(".sorting_asc input");
  const chackboxFun = (type) => {
    for (let i = 0; i < chackbox.length; i++) {
      const element = chackbox[i];
      if (type === "all") {
        if (motherChackBox.checked) {
          element.checked = true;
        } else {
          element.checked = false;
        }
      } else {
        if (!element.checked) {
          motherChackBox.checked = false;
          break;
        } else {
          motherChackBox.checked = true;
        }
      }
    }
  };

  return (
    <Col lg={12}>
      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div className="input-group search-area d-lg-inline-flex d-none">
            <div className="input-group-append">
              <button className="input-group-text">
                <i className="flaticon-381-search-2" />
              </button>
            </div>
            <input
              type="text"
              id="myInput"
              onChange={(e) => {
                searchFunction(e.target.value);
              }}
              className="form-control"
              placeholder="Search here..."
            />
          </div>
          <Card.Title>
            <button
              className="btn btn-primary"
              onClick={() => {
                history.push("/state");
              }}
            >
              Back
            </button>
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <table
            className="display w-100 dataTable "
            id="myTable"
            role="grid"
            aria-describedby="example5_info"
          >
            <thead>
              <tr>
                <th
                  className="sorting_asc"
                  tabIndex={0}
                  aria-controls="example5"
                  rowSpan={1}
                  colSpan={1}
                  aria-sort="ascending"
                  aria-label=" : activate to sort column descending"
                  style={{ width: 32 }}
                >
                  <div className="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      onClick={() => chackboxFun("all")}
                      className="custom-control-input"
                      id="checkAll"
                      required
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="checkAll"
                    />
                  </div>
                </th>
                <th>
                  <strong className="text-white">SL No.</strong>
                </th>
                <th>
                  <strong className="text-white">CITY/DISTRICT</strong>
                </th>
                <th>
                  <strong className="text-white">VIEW/ADD</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {distValue &&
                distValue.map((val) => {
                  return (
                    <tr>
                      <td className="sorting_1">
                        <div className="custom-control custom-checkbox ">
                          <input
                            type="checkbox"
                            onClick={() => chackboxFun()}
                            className="custom-control-input"
                            id="customCheckBox1"
                            required
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customCheckBox1"
                          />
                        </div>
                      </td>
                      <td>
                        <strong>{val.id}</strong>
                      </td>
                      <td>{val.name}</td>
                      {distNames.includes(val.path) ? (
                        <td>
                          <Link to={`/pincode-view/${val.path}`}>
                            <Button className="btn btn-primary">View</Button>
                          </Link>
                          <Link to={`/pincode/${val.path}`}>
                            <Button className="btn btn-primary ml-2">
                              Update
                            </Button>
                          </Link>
                        </td>
                      ) : (
                        <td>
                          <Link to={`/pincode/${val.path}`}>
                            <Button className="btn btn-primary">
                              Add Geofence
                            </Button>
                          </Link>
                        </td>
                      )}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default City;
